class Tabulator {
  constructor(account) {
    this.account = account;
    this.userTabs = ['refer', 'rewards', 'referral'];
    this.visitorTabs = ['about'];
  }

  getTag(id) {
    return id;
  }

  getTitle(id) {
    return id;
  }

  list() {
    const tabs = this.account ? this.userTabs : this.visitorTabs;
    return tabs;
  }

  getActive() {
    const currentTag = window.location.hash.split('#')[1];
    if (this.list().includes(currentTag)) return currentTag;
    return this.account ? this.getTag('refer') : this.getTag('about');
  }

  isActive(tag) {
    return this.getActive() === this.getTag(tag);
  }

  onChange(tag) {
    if (window.location.hash !== tag) {
      const currentURL = new URL(window.location);
      currentURL.hash = tag;
      window.history.pushState({}, '', currentURL);
    }
    return this.getActive();
  }
}

export default Tabulator;
